import React, {Component} from 'react';
import {connect, Provider} from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import UserBlock from './Elements/UserBlock';
import SideNav from './Elements/SideNav';
import historyComponent from './hoc/historyComponent';
import utilities from '../utilities/utilities';
import LegalPopup from './Elements/LegalPopup';
import store from '../store/store';
import {openOlarkChat} from '../helpers/olarkLoader';
import * as actionCreators from '../store/actions';
import FeedbackPopup from './Elements/FeedbackPopup';
import Logo from './Elements/Logo';
import AutocompleteHeader from './Elements/AutocompleteHeader';
import {sitemapLink, sitemapTitle} from './Containers/Sitemap';
import {browseLink} from './Containers/Browse';
import buildBrowseHrefFromLocation from './Containers/Browse/browseHrefFromLocation';
import {renderReactNode} from '../helpers/reactDomCompat';

const propTypes = {
  commonData: PropTypes.instanceOf(Object),
  pageData: PropTypes.instanceOf(Object),
  userData: PropTypes.instanceOf(Object).isRequired,
  mapData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  doc: PropTypes.string.isRequired,
  isFront: PropTypes.func.isRequired,
  isActive: PropTypes.func.isRequired,
  isDocView: PropTypes.func.isRequired,
  setHeaderUpdating: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  menuCollapsed: PropTypes.bool.isRequired,
  navigationPlace: PropTypes.instanceOf(Object),
};

const defaultProps = {
  commonData: {},
  pageData: {},
  navigationPlace: null,
};

class Header extends Component {
  static openFeedbackPopup(e) {
    e.preventDefault();
    renderReactNode(
      <Provider store={store}>
        <FeedbackPopup />
      </Provider>,
      document.getElementById('popup-container'),
    );
  }

  static switchOlark(e) {
    openOlarkChat(e);
  }

  constructor(props) {
    super(props);

    this.state = {
      showToolsMenu: false,
      showGridicsMenu: false,
    };

    this.toggleToolsMenu = this.toggleToolsMenu.bind(this);
    this.openLegalPopup = this.openLegalPopup.bind(this);
    this.closeToolsMenu = this.closeToolsMenu.bind(this);
    this.toggleGridicsMenu = this.toggleGridicsMenu.bind(this);

    this.sideNavRef = React.createRef();

    document.addEventListener('click', this.closeToolsMenu);
  }

  shouldComponentUpdate(nextProps) {
    const {isMobile, setHeaderUpdating} = this.props;
    if (nextProps.isMobile !== isMobile) {
      setHeaderUpdating(true);
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    const {isMobile, setHeaderUpdating} = this.props;
    if (isMobile !== prevProps.isMobile) {
      setTimeout(() => {
        setHeaderUpdating(false);
      }, 0);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeToolsMenu);
  }

  toggleToolsMenu(e) {
    e.preventDefault();
    const {showToolsMenu} = this.state;
    this.setState({showToolsMenu: !showToolsMenu});
  }

  toggleGridicsMenu(e) {
    e.preventDefault();
    const {showGridicsMenu} = this.state;
    this.setState({showGridicsMenu: !showGridicsMenu});
  }

  closeToolsMenu(e) {
    const {showToolsMenu} = this.state;
    if (showToolsMenu && !e.target.closest('.toggle-menu')) {
      this.setState({showToolsMenu: false});
    }
  }

  showSearchBlock() {
    const {isFront} = this.props;
    return !isFront();
  }

  openLegalPopup(e) {
    e.preventDefault();
    // Show popup with legal disclaimer notice.
    renderReactNode(
      <Provider store={store}>
        <LegalPopup {...this.props} />
      </Provider>,
      document.getElementById('popup-container'),
    );
  }

  toolsMenuHtml() {
    const {userData, isMobile, location} = this.props;
    const {showGridicsMenu} = this.state;
    const loggedIn = utilities.isLoggedIn(userData);
    const marketingSiteUrl = 'https://www.gridics.com';
    const {navigationPlace} = this.props;
    const marketPath = navigationPlace?.url || navigationPlace?.path || '';
    const allPropertiesHref = buildBrowseHrefFromLocation(location, marketPath);
    return (
      <React.Fragment>
        <ul className="toggle-menu">
          {isMobile
            && (() => (
              <React.Fragment>
                <li>
                  <a href="#sub-menu" className="submenu-link" onClick={this.toggleGridicsMenu} title="Gridics menu">
                    <span className="title">Gridics</span>
                  </a>
                  <div className={`submenu gridics-submenu${!showGridicsMenu ? ' hide' : ''}`}>
                    <ul>
                      <li>
                        <a href={allPropertiesHref}>All Properties</a>
                      </li>
                      <li>
                        <a href={`${marketingSiteUrl}/team`} target="_blank" rel="noopener noreferrer">
                          About Us
                          <i className="icon-b icon-b-external" />
                        </a>
                      </li>
                      <li>
                        <a href="#feedback-form" onClick={Header.openFeedbackPopup}>
                          Give Feedback
                        </a>
                      </li>
                      <li>
                        <a onClick={this.openLegalPopup} href="#legal">
                          Disclaimer
                        </a>
                      </li>
                      <li>
                        <a href={`${marketingSiteUrl}/privacy`} target="_blank" rel="noopener noreferrer">
                          Privacy Policy
                          <i className="icon-b icon-b-external" />
                        </a>
                      </li>
                      <li>
                        <a href={`${marketingSiteUrl}/terms`} target="_blank" rel="noopener noreferrer">
                          Privacy Policy
                          <i className="icon-b icon-b-external" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <a href={sitemapLink}>
                    <span className="title">{sitemapTitle}</span>
                  </a>
                </li>
                <li>
                  <a onClick={Header.switchOlark} href="#contact-us">
                    <span className="title">Contact Us</span>
                  </a>
                </li>
              </React.Fragment>
            ))()}
        </ul>
        {isMobile && (
          <div className="side-nav-menu-bottom">
            {loggedIn && isMobile && (
              <a className="signout" href={utilities.getDestinationUrl('logout')}>
                Sign Out
              </a>
            )}
            <div className="powered">Powered by Gridics</div>
          </div>
        )}
      </React.Fragment>
    );
  }

  mobileSideNav() {
    const {history} = this.props;
    const isLandingPage = history.location.pathname === '/';

    return (
      <React.Fragment>
        <header id="header">
          <div className="header-inner mobile">
            <Logo />
            {!isLandingPage && <AutocompleteHeader />}
            <SideNav ref={this.sideNavRef}>
              <UserBlock sideNavRef={this.sideNavRef} urlPath={history.location.pathname} />
              {this.toolsMenuHtml()}
            </SideNav>
          </div>
        </header>
      </React.Fragment>
    );
  }

  render() {
    const {userData, isMobile, history} = this.props;
    const loggedIn = utilities.isLoggedIn(userData);
    const isLandingPage = history.location.pathname === '/';
    const isSitemapPage = history.location.pathname === sitemapLink;
    const isBrowsePage = history.location.pathname === browseLink || history.location.pathname.startsWith(`${browseLink}/`);
    let content = '';
    if (isMobile) {
      content = this.mobileSideNav();
    }
    else {
      content = (
        <header id="header">
          <div className="header-inner desktop">
            {(isLandingPage || isSitemapPage || isBrowsePage) && (
              <div className="home-page-logo">
                <Logo />
              </div>
            )}
            {!isLandingPage && !isSitemapPage && !isBrowsePage && <AutocompleteHeader />}
            {(isSitemapPage || isBrowsePage) && (
              <div className="sitemap-autocomplete">
                <AutocompleteHeader />
              </div>
            )}
            <div id="active-filters" className="active-filters" />
            <div className={classnames('tools-and-user', {'not-logged': !loggedIn})}>
              {this.toolsMenuHtml()}
              <UserBlock isHomePage urlPath={history.location.pathname} />
            </div>
          </div>
        </header>
      );
    }
    return content;
  }
}

Header.defaultProps = defaultProps;
Header.propTypes = propTypes;

const mapStateToProps = state => ({
  pageData: state.doc.pageData,
  mapData: state.map.mapData,
  userData: state.user.userData,
  commonData: state.common.commonData,
  userDataFetched: state.user.userDataFetched,
  isMobile: state.ui.isMobile,
  headerUpdating: state.ui.headerUpdating,
  menuCollapsed: state.ui.menuCollapsed,
  navigationPlace: state.map.navigation.place,
});

const mapDispatchToProps = dispatch => ({
  setHeaderUpdating: state => dispatch(actionCreators.setHeaderUpdating(state)),
});

export default historyComponent(connect(mapStateToProps, mapDispatchToProps)(Header));
